import React from "react";
import { Input, FormFeedback, Label } from "reactstrap";
import { useStatusFindAllQuery } from "store";

interface StatusSelectProps {
  formik: any;
  name?: string;
  label?: string;
  code?: string;
  placeholder?: string;
}

const StatusSelect: React.FC<StatusSelectProps> = ({
  formik,
  name = "status_id",
  label = "Төлөв",
  code,
  placeholder = "Сонгох...",
}) => {
  const { data, isLoading } = useStatusFindAllQuery(code ? `?code=${code}` : "");

  const options = data?.data ?? [];

  return (
    <div className="mb-3">
      <Label>{label}</Label>
      <Input
        type="select"
        name={name}
        onChange={formik.handleChange}
        onBlur={formik.handleBlur}
        value={formik.values[name] ?? ""}
        disabled={isLoading}
        invalid={formik.touched[name] && !!formik.errors[name]}
      >
        <option value="">{placeholder}</option>
        {options.map((status: any) => (
          <option key={status.id} value={status.id}>
            {status.name}
          </option>
        ))}
      </Input>
      {formik.touched[name] && formik.errors[name] && (
        <FormFeedback>{formik.errors[name]}</FormFeedback>
      )}
    </div>
  );
};

export default StatusSelect;
